export const FOOTER_BANNER_MAX_RATIO = 5;
export const FOOTER_BANNER_MIN_RATIO = 4;

export const POPUP_BANNER_MAX_RATIO = 1.6;
export const POPUP_BANNER_MIN_RATIO = 1.4;
